import Swiper from "swiper";
import { Navigation, Autoplay, A11y, Thumbs, Mousewheel, Pagination } from "swiper/modules";

export default {
    name: 'slider',
    component() {
        return {
            initSlider() {
                const slider = this.$root.querySelector(".swiper");
                new Swiper(slider, {
                    modules: [Autoplay, A11y, Navigation],
                    direction: "horizontal",
                    loop: true,
                    slidesPerView: 1.20,
                    allowTouchMove: true,
                    disableOnInteraction: false,
                    spaceBetween: 15,
                    breakpoints: {
                        750: {
                            slidesPerView: 2.5,
                            spaceBetween: 15,
                        },
                        1000: {
                            slidesPerView: 3,
                            spaceBetween: 30,
                        },
                    },
                    navigation: {
                        nextEl: this.$root
                            .querySelector("[data-slider-btn-next]"),
                        prevEl: this.$root
                            .querySelector("[data-slider-btn-prev]"),
                    },
                });
            },

            initSliderCta(delayTime) {
                const slider = this.$root.querySelector(".swiper");
                new Swiper(slider, {
                    modules: [Autoplay, A11y, Pagination],
                    direction: "horizontal",
                    loop: true,
                    slidesPerView: 1,
                    allowTouchMove: true,
                    disableOnInteraction: false,
                    spaceBetween: 15,
                    autoplay: {
                        delay: delayTime,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                    },
                    pagination: {
                        el: this.$root.querySelector("[data-slider-pagination]"),
                        clickable: true,
                        type: 'bullets',
                    },
                    breakpoints: {
                        750: {
                            spaceBetween: 20,
                        },
                        1000: {
                            spaceBetween: 30,
                        },
                    },
                    on: {
                        init: (swiper) => {
                            setTimeout(() => {
                                swiper.slideNext();
                            }, delayTime);
                        },
                    },
                });
            },

            initSliderProduct() {
                const slider = this.$root.querySelector(".swiper");
                const sliderThumbs = this.$root.querySelector(".swiper--thumbs");
                const mainSwiper = new Swiper(slider, {
                    modules: [Autoplay, A11y, Navigation, Thumbs],
                    direction: "horizontal",
                    loop: false,
                    slidesPerView: 1,
                    allowTouchMove: true,
                    disableOnInteraction: false,
                    spaceBetween: 10,
                    breakpoints: {
                        750: {
                            spaceBetween: 20,
                        },
                    },
                    thumbs: {
                        swiper: sliderThumbs,
                    },
                });
                slider.productSwiper = mainSwiper;

                const section = this.$root.closest('[data-section]');
                if (section) {
                    const script = section.querySelector('[data-product-variant-media-index]');
                    const variantInput = section.querySelector('input[name="id"]');
                    const variantId = variantInput?.value;
                    if (script && variantId) {
                        try {
                            const map = JSON.parse(script.textContent);
                            const index = map[variantId];
                            if (typeof index === 'number') {
                                mainSwiper.slideTo(index);
                            }
                        } catch (_) {}
                    }
                }

                // if(window.innerWidth > 999) {
                    new Swiper(sliderThumbs, {
                        modules: [Autoplay, A11y, Navigation, Thumbs],
                        direction: "horizontal",
                        loop: false,
                        slidesPerView: "auto",
                        allowTouchMove: true,
                        disableOnInteraction: false,
                        spaceBetween: 15,
                        // thumbs: {
                        //     swiper: sliderThumbs,
                        // },
                    });
                // }
            },

            initSliderBrands() {
                const slider = this.$root.querySelector(".swiper");
                new Swiper(slider, {
                    modules: [Autoplay, A11y],
                    direction: "horizontal",
                    loop: true,
                    slidesPerView: "auto",
                    allowTouchMove: true,
                    disableOnInteraction: false,
                    speed: 3000,
                    autoplay: {
                        delay: 1,
                        disableOnInteraction: false,
                    },
                    spaceBetween: '11%',
                    on: {
                        init: (swiper) => {
                            setTimeout(() => {
                                swiper.slideNext();
                            }, 200);
                        },
                    },
                });
            },

            initSliderReviews(startIndex) {
                const slider = this.$root.querySelector(".swiper");
                new Swiper(slider, {
                    modules: [Autoplay, A11y, Navigation, Mousewheel],
                    direction: "horizontal",
                    loop: true,
                    slidesPerView: 1,
                    initialSlide: startIndex,
                    allowTouchMove: true,
                    disableOnInteraction: false,
                    spaceBetween: 15,
                    loopAdditionalSlides: 5,
                    autoplay: {
                        delay: 2000,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                    },
                    mousewheel: {
                        forceToAxis: true,
                        releaseOnEdges: true,
                    },
                    breakpoints: {
                        750: {
                            slidesPerView: 2.25,
                            spaceBetween: 50,
                        },
                        1000: {
                            slidesPerView: 1,
                            spaceBetween: 140,
                        },
                    },
                    on: {
                        init: (swiper) => {
                            setTimeout(() => {
                                swiper.slideNext();
                            }, 2000);
                        },
                    },
                });
            },

            initSliderOffer() {
                const slider = this.$root.querySelector(".swiper");
                new Swiper(slider, {
                    modules: [Autoplay, A11y, Navigation, Mousewheel],
                    direction: "horizontal",
                    loop: false,
                    slidesPerView: 1.05,
                    allowTouchMove: true,
                    disableOnInteraction: false,
                    spaceBetween: 10,
                    mousewheel: {
                        forceToAxis: true,
                        releaseOnEdges: true,
                    },
                    breakpoints: {
                        750: {
                            slidesPerView: 2,
                            spaceBetween: 10,
                        },
                        1000: {
                            slidesPerView: 2,
                            spaceBetween: 20,
                        },
                    },
                });
            },

            initSliderBlocks() {
                const slider = this.$root.querySelector(".swiper");
                new Swiper(slider, {
                    modules: [Autoplay, A11y, Navigation],
                    direction: "horizontal",
                    loop: false,
                    slidesPerView: 1.05,
                    allowTouchMove: true,
                    disableOnInteraction: false,
                    spaceBetween: 10,
                    breakpoints: {
                        750: {
                            slidesPerView: 2.25,
                            spaceBetween: 15,
                        },
                        1000: {
                            slidesPerView: 3,
                            spaceBetween: 24,
                        },
                    },
                });
            },

            initSliderHistory() {
                const slider = this.$root.querySelector(".swiper");
                new Swiper(slider, {
                    modules: [Autoplay, A11y],
                    direction: "horizontal",
                    loop: false,
                    slidesPerView: 3,
                    allowTouchMove: true,
                    disableOnInteraction: false,
                    spaceBetween: 15,
                });
            },
        }
    }
}